module.exports = new __parcel__URL__("design-darkmode.c5a2c049.svg").toString();